import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface CookiePreferences {
  /** Always on — the app cannot work without these. */
  essential: true
  analytics: boolean
  marketing: boolean
}

interface CookieConsentState {
  decided: boolean
  preferences: CookiePreferences
  acceptAll: () => void
  rejectNonEssential: () => void
  save: (preferences: Omit<CookiePreferences, 'essential'>) => void
  reopen: () => void
}

const DEFAULTS: CookiePreferences = { essential: true, analytics: false, marketing: false }

/** Consent state for the cookie banner — Figma `cookies-banner` (2256:281989). */
export const useCookieConsentStore = create<CookieConsentState>()(
  persist(
    (set) => ({
      decided: false,
      preferences: DEFAULTS,
      acceptAll: () => {
        set({ decided: true, preferences: { essential: true, analytics: true, marketing: true } })
      },
      rejectNonEssential: () => {
        set({ decided: true, preferences: DEFAULTS })
      },
      save: (preferences) => {
        set({ decided: true, preferences: { essential: true, ...preferences } })
      },
      reopen: () => {
        set({ decided: false })
      },
    }),
    { name: 'corvinus-cookie-consent' },
  ),
)
